import React, { memo } from 'react';
import classnames from 'classnames/bind';
import { defaultTheme } from '@miroculus/nucleo';
import { miroPalette } from 'images';
import styles from './AuthPage.scss';
const cx = classnames.bind(styles);
const ThreeBubbles = () => (React.createElement("svg", { width: 180, height: 40 },
    React.createElement("circle", { r: 20, cx: 20, cy: 20, fill: defaultTheme.colorBubble1 }),
    React.createElement("circle", { r: 20, cx: 90, cy: 20, fill: defaultTheme.colorBubble2 }),
    React.createElement("circle", { r: 20, cx: 160, cy: 20, fill: defaultTheme.colorBubble3 })));
const AuthPage = memo(({ children, additionalInfo, ssoButton, footerText }) => (React.createElement("div", { className: cx('container') },
    React.createElement("main", null,
        React.createElement("img", { src: miroPalette, alt: "Miro Palette" }),
        additionalInfo && (React.createElement("p", { className: cx('additionalInfo') }, additionalInfo)),
        ssoButton && (React.createElement(React.Fragment, null,
            ssoButton,
            React.createElement("p", { className: cx('or') }, "or"))),
        React.createElement("section", { className: cx('form-container') }, children),
        React.createElement("footer", null, footerText)),
    React.createElement("aside", null,
        React.createElement("h1", null, "Science Simplified"),
        React.createElement(ThreeBubbles, null),
        React.createElement("p", null, "By putting intuitive tools in the hands of people everywhere, we can advance science and improve lives faster, together.")))));
export default AuthPage;
